import React, { useState } from "react";
import { Container } from "@mui/material";
import { sendPurchaseInQuiry } from "../../api/contact";
import CloseIcon from "@mui/icons-material/Close";
import MessageModal from "../messagemodal";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";

const FIELDS = {
  userName: "userName",
  userEmail: "userEmail",
  userCompany: "userCompany",
  userSubject: "userSubject",
  userMessage: "userMessage",
};

const styles = {
  inputTextArea: {
    width: "100%",
    height: 170,
    resize: "none",
    padding: 15,
    fontFamily: "inherit",
    border: "1px solid rgba(199,199,199,0.5)",
    borderRadius: "5px",
    "&::placeholder": {
      color: "rgba(0,0,0,0.12)",
    },
  },
  buttonContainer: {
    textAlign: "center",
  },
  button: {
    width: "200px",
    height: "60px",
    textAlign: "center",
    margin: "5px",
    color: "#FFFFFF",
    borderRadius: "8px",
    textTransform: "none",
    textColor: "#FFFFFF",
    border: "none",
    fontSize: "24px",
  },
  backlink: {
    display: "block",
    textDecoration: "none",
    color: "#000",
    padding: "0",
  },
}

export const PurchaseInQuiry = (props) => {
  const [isSubmitEnabled, setIsSubmitEnabled] = useState(false);
  const [isMessageDialogOpen, setIsMessageDialogOpen] = useState(false);
  const {
    register,
    handleSubmit,
    getValues,
    reset,
  } = useForm();

  const handleFormBlur = (event) => {
    const formValues = getValues();
    const isNoEmptyFields = !Object.values(formValues).some((str) => str.length === 0);
    setIsSubmitEnabled(isNoEmptyFields);
  }

  const handleFormSubmit = async (data) => {
    const { sendInQuiryRet, sendInQuiryError } = await sendPurchaseInQuiry(data);
    setIsMessageDialogOpen(true);
  }

  const sendSubmit = async () => {
    reset();
    setIsSubmitEnabled(false);
  }

  const closeDeleteConfirmModal = () => {
      setIsMessageDialogOpen(false)
  }
  return (
    <>
        <Container className="ts_container">
          <div className="ts_content">
            <div className="title_green   ">
              <>
                お問合せ / Contact us
              </>
            </div>
            <div className="input_container inquiryForm">
              <form
                onBlur={handleFormBlur}
                onSubmit={handleSubmit(handleFormSubmit)}
              >
                <div className="field_container">
                  <div className="label required">氏名 / Name</div>
                  <input type="text" {...register(FIELDS.userName, {required: true})} className="field" maxLength={100} />
                </div>
                <div className="field_container">
                  <div className="label required">メールアドレス / Email address</div>
                  <input type="email" {...register(FIELDS.userEmail, {required: true})} className="field" maxLength={254} />
                </div>
                <div className="field_container">
                  <div className="label required">会社名 / Company</div>
                  <input type="text" {...register(FIELDS.userCompany, {required: true})} className="field" maxLength={100} />
                </div>
                <div className="field_container">
                  <div className="label required">件名 / Subject</div>
                  <input type="text" {...register(FIELDS.userSubject, {required: true})} className="field" maxLength={100} />
                </div>
                <div className="field_container">
                  <div className="label required">メッセージ / Message</div>
                  <textarea
                    type="text"
                    {...register(FIELDS.userMessage, {required: true})}
                    rows={7}
                    style={styles.inputTextArea}
                    maxLength={512}
                  />
                </div>
                <div className="button-container">
                  <button
                    type="submit"
                    variant="contained"
                    className={isSubmitEnabled ? `button-approve` : "button-disabled"}
                    disabled={!isSubmitEnabled}
                    color="primary"
                  >
                    送信 / Send
                  </button>
                  <button
                    type="button"
                    variant="contained"
                    className="button-delete"
                    color="primary"
                  >
                    <CloseIcon />
                    <Link style={{ display: "block", textDecoration: "none", color: "#000", padding: "0",}} to={`/`}>
                      戻る / Back
                    </Link>
                  </button>
                </div>
              </form>
            </div>
          </div>
          <MessageModal
            handleClose={closeDeleteConfirmModal}
            open={isMessageDialogOpen}
            message={"送信完了 / Email sent"}
            buttonText={"Ok"}
            type="check"
            go_back={sendSubmit}
          />
        </Container>
      </>
  )
}